var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer_wrap"},[_c('div',{staticClass:"main-container footer"},[_c('span',[_vm._v("版权所有：黄冈师范学院体育场馆中心")]),_vm._v(" "),_c('span',[_vm._v("电话：029-8888888")]),_vm._v(" "),_c('span',[_vm._v("邮箱：XXXXXXXX@163.com")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ba0708a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BottomFooter.vue
// module id = null
// module chunks = 